import {
  type CandidateRequestTransport,
  registerCandidateRequestTransport,
} from 'candidate-app/requestTransport';

const INTERVIEW_PREFIX = '/external-agent/interview';

export function externalAgentInterviewRequestUrl(url: string): string {
  const parsed = new URL(url, 'https://interview.invalid');
  const path = parsed.pathname;
  if (path.startsWith(`${INTERVIEW_PREFIX}/`)) return url;
  const belongsToInterview =
    path === '/candidate_capability' ||
    path === '/check_web_link' ||
    path === '/create_or_find_existing_candidate_call' ||
    path === '/web_call/funnel_event' ||
    path.startsWith('/interview_sessions/') ||
    path.startsWith('/scheduled_ai_web_calls/') ||
    /^\/call\/[^/]+\/scheduled_ai_web_call$/.test(path) ||
    /^\/web_call\/[^/]+\/campaign_settings_for_web_call$/.test(path);
  if (!belongsToInterview) return url;
  parsed.pathname = `${INTERVIEW_PREFIX}${path}`;
  return url.startsWith('/')
    ? `${parsed.pathname}${parsed.search}${parsed.hash}`
    : parsed.toString();
}

const externalAgentInterviewTransport: CandidateRequestTransport = {
  id: 'external-agent-interview',
  matchesLocation: (pathname, search) =>
    /^\/(?:web-interview|web-call|reschedule|reschedule-calendar)(?:\/|$)/.test(
      pathname
    ) && new URLSearchParams(search).get('externalAgent') === '1',
  mapRequestUrl: externalAgentInterviewRequestUrl,
  mapLaunchUrl: (url) => {
    const parsed = new URL(url);
    parsed.searchParams.set('externalAgent', '1');
    return parsed.toString();
  },
  canonicalRequestUrl: (url) => {
    const parsed = new URL(url, 'https://interview.invalid');
    if (!parsed.pathname.startsWith(`${INTERVIEW_PREFIX}/`)) return url;
    parsed.pathname = parsed.pathname.slice(INTERVIEW_PREFIX.length);
    return url.startsWith('/')
      ? `${parsed.pathname}${parsed.search}${parsed.hash}`
      : parsed.toString();
  },
};

/**
 * Routes an external agent's interview requests (`?externalAgent=1`) through
 * its own API paths. Called before the candidate app derives a credential:
 * from the interview app's boot requests and when its routes load.
 */
export function registerExternalAgentInterviewTransport(): void {
  registerCandidateRequestTransport(externalAgentInterviewTransport);
}
